<template>
  <div>
    <h5 class="package-title" v-translate>Tour components</h5>
    <b-card no-body class="border-top-0">
      <b-table-simple class="table table-sm mb-0" striped stacked="sm">
        <thead>
          <tr>
            <td><span v-translate class="ml-4">Name</span></td>
            <td v-translate>Period</td>
            <td v-translate>Ava</td>
            <td v-translate>Price</td>
            <td>&nbsp;</td>
          </tr>
        </thead>
        <tbody>
          <template v-for="(el, elIndex) in date.elements">
            <Element
              :index="elIndex"
              :element="el"
              :currency="currency"
              :checked="selection[elIndex]"
              :pax="pax"
              @change="onElementSelectionChange($event, elIndex)"
              @toggleSeatMap="$emit('toggleSeatMap', { direction: $event.direction, element: elIndex })"
              :key="'el' + elIndex" />
          </template>
        </tbody>
      </b-table-simple>
      <div class="p-2 text-danger text-center" style="font-size: .95rem;">
        Nu uitați să selectați locul în autocar de la pictograma aflată lângă serviciul
        <strong>
          “Transport autocar”!
        </strong>
      </div>
    </b-card>
  </div>
</template>

<script>
import Element from './element.vue'
export default {
  props: {
    date: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    selection: {
      type: Array,
      required: true
    },
    pax: {
      type: Array,
      required: true
    }
  },
  components: {
    Element
  },
  methods: {
    onElementSelectionChange (value, index) {
      this.$emit('change', { value, index })
    }
  }
}
</script>
